import { map } from 'fp-ts/Either';
/**
 *  @since 0.0.1
 */
export const IoTsURI = 'IoTsURI';
/**
 *  @since 0.0.1
 */
export class IOTSType {
    constructor(type) {
        this.type = type;
        this.create = a => map((x) => x)(this.type.decode(this.type.encode(a)));
    }
}
